// =============================================================================
// FILE: packages/renderer/src/stores/growthAgent.store.ts
// PURPOSE: Global state for the Emmy Growth Agent celebration toast.
//          Call `growthAgent.celebrate(event)` from anywhere in the renderer
//          to fire the toast. The toast auto-dismisses after 5.5 seconds.
// =============================================================================

import { create } from 'zustand';
import {
  type GrowthCelebration,
  type GrowthEventType,
  getGrowthCelebration,
} from '../services/growthAgent.js';

interface GrowthAgentState {
  celebration: GrowthCelebration | null;
  celebrate:   (event: GrowthEventType) => void;
  dismiss:     () => void;
}

export const useGrowthAgentStore = create<GrowthAgentState>((set) => ({
  celebration: null,
  celebrate: (event) => set({ celebration: getGrowthCelebration(event) }),
  dismiss:   ()      => set({ celebration: null }),
}));

/** Imperative API — call from anywhere without needing a React hook */
export const growthAgent = {
  celebrate: (event: GrowthEventType) =>
    useGrowthAgentStore.getState().celebrate(event),
  dismiss: () =>
    useGrowthAgentStore.getState().dismiss(),
};
